module.exports = __webpack_public_path__ + "static/media/WhitespaceBad.ed759a2b.png";